import React from "react"
import {ClearIcon, Icon, Input, SearchBar, SearchIcon} from "./components"
import SearchBarContainerComponent from "./searchBarContainer"
import env from "../../../../config/env"
import {TextModel} from "../../../../models/Text"

interface FilterSearchBarProps {
    setFreeTextSearchForFilter: (e: React.SyntheticEvent, filterName: string) => void
    freeTextFilterSearch: {[key: string]: string}
    clearFreeTextSearchForFilter: (filterName: string) => void
    text: TextModel
    filterName: string
    filterDisplayName: string
}
const FilterSearchBar = ({
    setFreeTextSearchForFilter,
    freeTextFilterSearch,
    clearFreeTextSearchForFilter,
    text,
    filterName,
    filterDisplayName,
}: FilterSearchBarProps) => {
    return (
        <SearchBarContainerComponent>
            <SearchBar data-testid={`plp-hf-${filterName}-search-bar`}>
                <Input
                    autoComplete="off"
                    placeholder={`${text.pages.filters.searchCategory} ${filterDisplayName}s`}
                    onChange={e => setFreeTextSearchForFilter(e, filterName)}
                    value={freeTextFilterSearch[filterName]}
                    data-testid={`plp-hf-${filterName}-search-bar-input`}
                />
                {(freeTextFilterSearch[filterName] === undefined || freeTextFilterSearch[filterName] === "") && (
                    <SearchIcon>
                        <Icon
                            src={`${env.REACT_APP_BLOB_STORAGE_PATH}/icons/shared/next_search-black.svg`}
                            alt={text.imageAlts.tabbedSearchCategory}
                        />
                    </SearchIcon>
                )}
                {freeTextFilterSearch[filterName] && freeTextFilterSearch[filterName] !== "" && (
                    <ClearIcon>
                        <Icon
                            src={`${env.REACT_APP_BLOB_STORAGE_PATH}/icons/shared/clear.svg`}
                            alt={text.imageAlts.tabbedSearchCategory}
                            onClick={() => clearFreeTextSearchForFilter(filterName)}
                            data-testid={`plp-hf-${filterName}-search-bar-clear`}
                        />
                    </ClearIcon>
                )}
            </SearchBar>
        </SearchBarContainerComponent>
    )
}

export default FilterSearchBar
